"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const get_css_1 = __importDefault(require("../get-css"));
exports.propTypes = {
    bottom: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    left: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    position: prop_types_1.default.string,
    right: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    top: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number])
};
exports.propAliases = {};
exports.propValidators = {};
const position = {
    className: 'pst',
    cssName: 'position',
    jsName: 'position',
    safeValue: true,
    isPrefixed: true
};
const top = {
    className: 'top',
    cssName: 'top',
    jsName: 'top'
};
const right = {
    className: 'rgt',
    cssName: 'right',
    jsName: 'right'
};
const bottom = {
    className: 'btm',
    cssName: 'bottom',
    jsName: 'bottom'
};
const left = {
    className: 'lft',
    cssName: 'left',
    jsName: 'left'
};
exports.propEnhancers = {
    bottom: (value) => get_css_1.default(bottom, value),
    left: (value) => get_css_1.default(left, value),
    position: (value) => get_css_1.default(position, value),
    right: (value) => get_css_1.default(right, value),
    top: (value) => get_css_1.default(top, value)
};
//# sourceMappingURL=data:application/json;base64,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